// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__32O84","content":"RecentSearches_content__15C1z"};